interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "CHF";
};

const CHF: Currency = Object.freeze({
  "displayName": "Swiss Franc",
  "numericCode": 756,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "before",
  "isoCode": "CHF",
  "symbol": "Fr."
});

export { CHF };
